export default __webpack_public_path__ + "static/media/Board.31271037.svg";